import { useState, useEffect, useCallback } from "react";
import { Link } from "react-router-dom";
import * as dashboardService from "../services/dashboard.services";
import { useTranslation } from "react-i18next";
import ApexCharts from "react-apexcharts"; 
import moment from 'moment';

const Dashboard = () => {
  const { t } = useTranslation();
  const [showDashboardCount, setShowDashboardCount] = useState({});
  
  const currentYear = moment().year(); 
  const currentMonth = moment().month() + 1;
  
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  
  const [chartData, setChartData] = useState({
    series: [
      {
        name: "Users",
        data: [] 
      },
      {
        name: "Advertisers",
        data: [] 
      }
    ],
    options: {
      chart: {
        id: "user-streamer-chart",
        type: "line",
        height: 350,
        toolbar: {
          show: false,
        }
      },
      xaxis: {
        categories: []
      },
      yaxis: {
        title: {
          text: "Count"
        }
      },
      grid: {
        show: true, 
        borderColor: "#f1f1f1",
      },
      stroke: {
        curve: "smooth" 
      },
    }
  });

  const fetchChartData = useCallback(async () => {
    try {
      const response = await dashboardService.chart(selectedMonth, selectedYear);
      console.log(`>>>>>fetchChartData>>>>`, response);

      const responseInArray = response.data;
      console.log(`>>>responseInArray>>`, responseInArray);
      
      if (responseInArray && responseInArray.length > 0) {
        const dates = responseInArray.map(item => item.date.split("-")[2]);
        console.log(`>>>>dates>>>`, dates);

        const userCount = responseInArray.map(item => item.user_count);
        console.log(`>>>>>userCount>>>>`, userCount);

        const advertiserCount = responseInArray.map(item => item.advertiserCount);
        console.log(`>>>>advertiserCount>>>`, advertiserCount);
        
        setChartData(prevState => ({
          series: [
            {
              name: "Users",
              data: userCount
            },
            {
              name: "Advertisers",
              data: advertiserCount
            }
          ],
          options: {
            ...prevState.options,
            xaxis: {
              categories: dates
            }
          }
        }));
      } else {
        setChartData(prevState => ({
          ...prevState,
          series: [
            { name: "Users", data: [] },
            { name: "Advertisers", data: [] }
          ],
          options: {
            ...prevState.options,
            xaxis: {
              categories: []
            }
          }
        }));
      }
    } catch (error) {
      console.error('Chart API Error:', error);
      setChartData(prevState => ({
        ...prevState,
        series: [
          { name: "Users", data: [] },
          { name: "Advertisers", data: [] }
        ],
        options: {
          ...prevState.options,
          xaxis: {
            categories: []
          }
        }
      }));
    }
  }, [selectedMonth, selectedYear]);

  const handleMonthChange = (e) => {
    const month = parseInt(e.target.value);
    setSelectedMonth(month);
  };

  const handleYearChange = (e) => {
    const year = parseInt(e.target.value);
    if (year <= currentYear) {
      setSelectedYear(year);
    }
  };

  useEffect(() => {
    fetchChartData();
  }, [fetchChartData]);

  useEffect(() => {
    dashboardService.Counts()
      .then((response) => {      
        const data = response && response.data ? response.data : {};
        console.log(`>>>data>>>>`, data);
        setShowDashboardCount(data);
      })
      .catch((error) => {
        console.log("Error fetching counts:", error);
      });
  }, []);

  const yearOptions = Array.from({length: 6}, (_, i) => currentYear - 5 + i);

  return (
    <>
      <div className="row row-sm animation_fade">
        <div className="col-sm-12 col-lg-12 col-xl-12">
          <div className="row row-sm">
            {/* Total Count Cards */}
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <Link to={`/admin/customers/list/1`}>
                <div className="card custom-card">
                  <div className="card-body cp">
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" className="bi bi-people-fill" viewBox="0 0 16 16">
                          <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                        </svg>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">{t("sidebar_link_users")}</label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">{showDashboardCount?.users || "0"}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>
            
            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-3">
              <Link to={`/admin/streamers/list/1`}>
                <div className="card custom-card">
                  <div className="card-body cp">
                    <div className="card-item">
                      <div className="card-item-icon card-icon cp">
                        <svg xmlns="http://www.w3.org/2000/svg" height="24" className="bi bi-people-fill" viewBox="0 0 16 16">
                          <path d="M3 14s-1 0-1-1 1-4 6-4 6 3 6 4-1 1-1 1zm5-6a3 3 0 1 0 0-6 3 3 0 0 0 0 6" />
                        </svg>
                      </div>
                      <div className="card-item-title mb-2">
                        <label className="main-content-label tx-13 font-weight-bold mb-1">{t("sidebar_link_advertiser")}</label>
                      </div>
                      <div className="card-item-body">
                        <div className="card-item-stat">
                          <h4 className="font-weight-bold">{showDashboardCount?.sellers || "0"}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </Link>
            </div>

            <div className="col-sm-12 col-md-6 col-lg-6 col-xl-6 mb-4">
              <div className="card custom-card">
                <div className="card-body">
                  <div className="row g-3 align-items-end">
                    <div className="col-md-6">
                      <label className="form-label">Month</label>
                      <select 
                        className="form-select" 
                        value={selectedMonth}
                        onChange={handleMonthChange}
                      >
                        {moment.months().map((month, index) => (
                          <option key={index+1} value={index+1}>
                            {month}
                          </option>
                        ))}
                      </select> 
                    </div>
                    <div className="col-md-6">
                      <label className="form-label">Year</label>
                      <select 
                        className="form-select" 
                        value={selectedYear}
                        onChange={handleYearChange}
                      >
                        {yearOptions.map(year => (
                          <option key={year} value={year}>{year}</option>
                        ))}
                      </select> 
                    </div>
                  </div>
                  <div className="mt-2 text-muted small">
                    📅 Only past data available (up to {currentYear})
                  </div>
                </div>
              </div>
            </div>

            <div className="col-sm-12">
              <div className="card custom-card">
                <div className="card-body">
                  <div className="row">
                    <div className="col-md-6 mb-4">
                      <div className="bg-white shadow-md rounded-lg p-6">
                        <h4 className="text-xl font-bold mb-4">User & Advertiser Growth</h4>
                        <ApexCharts
                          options={chartData.options}
                          series={chartData.series}
                          type="line"
                          height={350}
                        />
                      </div>
                    </div>
                    <div className="col-md-6 mb-4">
                      <div className="bg-white shadow-md rounded-lg p-6">
                        <h4 className="text-xl font-bold mb-4">Growth Summary</h4>
                        <div className="row text-center">
                          <div className="col-6 border-end">
                            <h3 className="text-primary">
                              {chartData.series[0]?.data?.reduce((a, b) => a + b, 0) || 0}
                            </h3>
                            <p>Total Users</p>
                          </div>
                          <div className="col-6">
                            <h3 className="text-success">
                              {chartData.series[1]?.data?.reduce((a, b) => a + b, 0) || 0}
                            </h3>
                            <p>Total Advertisers</p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Dashboard;
